module.exports = __webpack_public_path__ + "img/b6.5df7916a.png";